import { HorizontalSeparator } from '../styles/layout';

interface HorizontalLineProps {
  $margin?: string;
}
export const HorizontalLine = ({ $margin }: HorizontalLineProps) => {
  return <HorizontalSeparator style={{ width: '100%' }} $margin={$margin} />;
};
